import { __spreadArray } from "tslib";
import { createReducer } from './create-reducer';
import { request } from './request';
import keys from 'lodash-es/keys';
import intersection from 'lodash-es/intersection';
import without from 'lodash-es/without';
import union from 'lodash-es/union';
import uniq from 'lodash-es/uniq';
import chunk from 'lodash-es/chunk';
import clone from 'lodash-es/clone';
import cloneDeep from 'lodash-es/cloneDeep';
// Actions
var defaultpeopleSearchURL = 'http://peoplesearch.web.gs.com:6119/GSPeopleSearch/GSPeopleSearch';
function getPeopleDetails(wantedKerbs, peopleSearchURL) {
  if (wantedKerbs === void 0) {
    wantedKerbs = [];
  }
  if (peopleSearchURL === void 0) {
    peopleSearchURL = defaultpeopleSearchURL;
  }
  return function (dispatch, getState) {
    var _a = getState().peopleDetails,
      map = _a.map,
      fetchingMap = _a.fetchingMap;
    var currentKerbs = keys(map);
    var pendingKerbs = keys(fetchingMap);
    var allCurrentAndPendingKerbs = union(currentKerbs, pendingKerbs);
    var missingUsers = uniq(without.apply(void 0, __spreadArray([wantedKerbs], intersection(allCurrentAndPendingKerbs, wantedKerbs))));
    return Promise.all(chunk(missingUsers, 20).map(function (ch) {
      return dispatch({
        type: 'Q',
        baseType: 'PEOPLE_DETAILS',
        callAPI: function () {
          return request.get(peopleSearchURL + "?lang=json&StrictSearch=true&kerberos=" + ch.join(','));
        },
        payload: {
          missingUsers: ch
        }
      });
    }));
  };
}
// Reducers
var defaultPeopleDetailsState = {
  fetchingMap: {},
  map: {},
  xhrError: undefined
};
function processResult(receivedPeople, currentMap) {
  var newMap = cloneDeep(currentMap);
  receivedPeople.forEach(function (person) {
    person.kerberos = person.gskerberosid;
    newMap[person.kerberos] = person;
  });
  return newMap;
}
function updateFetchingMap(missingUsers, currentMap, fetchingState) {
  var newMap = clone(currentMap);
  missingUsers.forEach(function (user) {
    if (fetchingState) {
      newMap[user] = true;
    } else {
      delete newMap[user];
    }
  });
  return newMap;
}
// From Typescript 2.9 and onwards, `@ts-ignore` only works for the next line, thus
// we need to repeat `@ts-ignore`s here:
var peopleDetailsApiActions = {
  // @ts-ignore
  REQ: function (state, action) {
    return Object.assign({}, state, {
      fetchingMap: updateFetchingMap(action.payload.missingUsers, state.fetchingMap, true)
    });
  },
  // @ts-ignore
  RECV: function (state, action) {
    return Object.assign({}, state, {
      fetchingMap: updateFetchingMap(action.response.people.map(function (p) {
        return p.gskerberosid;
      }), state.fetchingMap, false),
      map: processResult(action.response.people, state.map)
    });
  },
  // @ts-ignore
  XHR_ERROR: function (state, action) {
    return Object.assign({}, state, {
      fetchingMap: updateFetchingMap(action.payload.missingUsers, state.fetchingMap, false),
      xhrError: action.error
    });
  },
  CLEAR_CACHE: function () {
    return Object.assign({}, defaultPeopleDetailsState);
  }
};
var peopleDetailsReducer = createReducer('PEOPLE_DETAILS', defaultPeopleDetailsState, peopleDetailsApiActions);
export { getPeopleDetails, peopleDetailsReducer };